const STAFF_FLAG_KEY = 'agm_staff'

export function isAdminUser($auth) {
  return !!(
    $auth?.loggedIn &&
    ($auth.user?.is_admin || $auth.user?.role?.identifier === 'admin')
  )
}

export function markStaffTraffic() {
  if (!process.client) return
  try {
    window.localStorage.setItem(STAFF_FLAG_KEY, '1')
  } catch {
    return
  }
}

export function isStaffTraffic($auth) {
  if (isAdminUser($auth)) {
    markStaffTraffic()
    return true
  }
  if (!process.client) return false
  try {
    return window.localStorage.getItem(STAFF_FLAG_KEY) === '1'
  } catch {
    return false
  }
}
